import React from "react";
import {
  Workspaces,
  Badge,
  Payments,
  DateRange,
  PunchClock,
  FilterTiltShift,
  Timer,
  AccessTime,
  Paid,
  ViewWeek,
  Update,
  HourglassBottom,
  HistoryToggleOff,
  MilitaryTech,
  Bolt,
  Functions,
  AccountCircle,
  People,
  SportsBaseball,
  PermIdentity,
  RemoveCircleOutline,
  MonetizationOn,
  AddCard,
  Source,
  AccountBalance,
  PeopleAlt,
  AvTimer,
  BrandingWatermark,
  AddHome,
  Dns,
  ConfirmationNumber,
  ManageAccounts,
  Apartment,
  AttachMoney,
  Payment,
  CalendarViewWeek,
  CalendarViewDay,
  Weekend,
  Apps,
  ShoppingBasket,
  AllInclusive,
  Save,
  CreditCard,
  CropFree,
  Savings,
} from "@mui/icons-material";
import {
  Timeline,
  Groups,
  HourglassTop,
  EventNote,
  CalendarMonth,
  EventAvailable,
  GroupWork,
  CheckCircle,
} from "@mui/icons-material";
import { Person } from "@material-ui/icons";

// Downloads (Excel / PDF / CSV) show API dates (YYYY-MM-DD) as DD-MM-YYYY.
const exportDate = (value) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value ?? ""));
  if (match) return `${match[3]}-${match[2]}-${match[1]}`;
  return value === null || value === undefined || value === "" ? "N/A" : value;
};
export const earningHeaders = [
  {
    header: "Name",
    key: "name",
  },
  {
    header: "Action",
    key: "action",
  },
];

export const payScheduleKeyPair = [
  {
    key: "name",
    name: "Payrun name",
  },
  {
    key: "start_date",
    name: "Start date",
  },
  {
    key: "end_date",
    name: "End date",
  },
  {
    key: "num_of_employees",
    name: "Number of Employee",
  },
  {
    key: "run_date",
    name: "Pay date",
  },
  {
    key: "group_count",
    name: "Group count",
  },
  {
    key: "action",
    name: "Action",
  },
];

export const deductionHeaders = [
  { header: "Name", key: "name" },
  { header: "Deduction Type", key: "deduction_type_display" },
  { header: "Action", key: "action" },
];

export const ComponentTypeDetails = [
  {
    label: "Earnings",
  },
  {
    label: "Deduction",
  },
  {
    label: "Expense",
  },
];

export const overTime = [
  {
    label: "Hour",
  },
  {
    label: "Day",
  },
];

export const PayRollEmployeeHeader = [
  {
    header: "Employee Name",
    key: "employee name",
  },
  {
    header: "Employee Id",
    key: "employeeid",
  },
  {
    header: "Cost to company (per year)",
    key: "",
  },
  {
    header: "Payroll Group",
    key: "payroll_group",
  },
  {
    header: "Status",
    key: "status",
  },
  {
    header: "Action",
    key: "",
  },
];

export const PaymentMode = [
  {
    label: "NEFT",
  },
  {
    label: "Cash",
  },
  {
    label: "Cheque",
  },
];

export const summaryDetails = [
  {
    label: "Cost Structure",
  },
  {
    label: "Attendance Timeline",
  },
  // {
  //   label: "Over Time",
  // },
  // {
  //   label: "Salary Revision",
  // },
];

export const salaryRevisionKeyPair = [
  {
    name: "Employee Name",
  },
  {
    name: "Employee Id",
  },
  {
    name: "Old CTC",
  },
  {
    name: "Revised CTC",
  },
  {
    name: "Revision Month",
  },
];

export const salaryStatementReportPart1 = [
  {
    name: "Employee Name",
    key: "user_name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Employee ID",
    key: "employee_id",
    type: "string",
    icon: <Person fontSize="small" />,
  },
  {
    name: "DOJ",
    key: "date_of_joining",
    type: "string",
    icon: <Person fontSize="small" />,
  },
  {
    name: "Department",
    key: "department",
    type: "Weekend",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Monthly CTC",
    key: "monthly_ctc",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Per day",
    key: "per_day_salary",
    type: "number",
    icon: <ShoppingBasket fontSize="small" />,
  },
  {
    name: "Per hour",
    key: "per_hour_salary",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Working Hours",
    key: "total_hours",
    type: "time",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Payable Hours",
    key: "payable_hours",
    type: "time",
    icon: <Badge fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Shift Hours",
    key: "paid_hours",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Total Present Days",
    key: "total_present_days",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Total Leave Days",
    key: "total_leave_days",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Paid Days",
    key: "working_days",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "OT Hours",
    key: "ot_hours",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Weekoff Hours",
    key: "weekoff_hours",
    type: "time",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Holiday Hours",
    key: "holiday_hours",
    type: "time",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Shift Duration",
    key: "shift_duration",
    type: "time",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "LOP",
    key: "lop",
    type: "number",
    icon: <AllInclusive fontSize="small" />,
  },
  {
    name: "LOP Amount",
    key: "lop_amount",
    type: "number",
    icon: <Save fontSize="small" />,
  },
  {
    name: "Gross",
    key: "gross_pay",
    type: "number",
    icon: <CreditCard fontSize="small" />,
  },
];

export const salaryStatementReportPart2 = [
  {
    name: "Total Deductions",
    key: "total_deductions",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Net Pay",
    key: "net_pay",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Mode of payment",
    key: "mode_of_payment",
    type: "autocomplete",
    icon: <Apps fontSize="small" />,
  },

  {
    name: "Bank",
    key: "bank",
    type: "autocomplete",
    icon: <AccountBalance fontSize="small" />,
  },
  {
    name: "ESI",
    key: "esi_no",
    type: "string",
    icon: <Savings fontSize="small" />,
  },
  {
    name: "PF",
    key: "pf_no",
    type: "string",
    icon: <CropFree fontSize="small" />,
  },
  {
    name: "UAN",
    key: "uan_no",
    type: "string",
    icon: <AccountBalance fontSize="small" />,
  },
];

export const ESIReportKeys = [
  {
    name: "Employee Name",
    key: "user_name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Employee ID",
    key: "employee_id",
    type: "string",
    icon: <Person fontSize="small" />,
  },
  {
    name: "ESI No",
    key: "esi_no",
    type: "string",
    icon: <ConfirmationNumber fontSize="small" />,
  },
  {
    name: "Gross Salary",
    key: "gross_pay",
    type: "number",
    icon: <Payment fontSize="small" />,
  },
  {
    name: "Per day salary",
    key: "per_day_salary",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Number of days in ESI",
    key: "paid_days",
    type: "number",
    icon: <CalendarViewWeek fontSize="small" />,
  },
  {
    name: "Employee contribution",
    key: "employee_esi",
    type: "number",
    icon: <CalendarViewDay fontSize="small" />,
  },
  {
    name: "Company contribution",
    key: "company_esi",
    type: "number",
    icon: <Weekend fontSize="small" />,
  },
  {
    name: "Total esi amount",
    key: "total_esi",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
];

export const EPFReportKeys = [
  {
    name: "Employee Name",
    key: "user_name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Employee ID",
    key: "employee_id",
    type: "string",
    icon: <Person fontSize="small" />,
  },
  {
    name: "PF No",
    key: "pf_no",
    type: "string",
    icon: <ConfirmationNumber fontSize="small" />,
  },
  {
    name: "Employee Contribution",
    key: "employee_pf",
    type: "number",
    icon: <ManageAccounts fontSize="small" />,
  },
  {
    name: "Company Contribution",
    key: "employer_pf",
    type: "number",
    icon: <Apartment fontSize="small" />,
  },
  {
    name: "Total Contribution",
    key: "total_contribution",
    type: "number",
    icon: <AttachMoney fontSize="small" />,
  },
];

export const IncentiveHeader = [
  {
    name: "Incentive Name",
    key: "name",
  },
  {
    name: "Incentive Type",
    key: "incentive_type",
  },
  {
    name: "Calculation Mode",
    key: "calculation_mode",
  },
  {
    name: "Status",
    key: "status",
  },
  {
    name: "Actions",
    key: "actions",
  },
];

export const incentiveMode = [
  { label: "fixed" },
  // { label: "percentage" },
  // { label: "unit" },
];

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const payCycle = [
  {
    id: 1,
    label: "Weekly",
  },
  {
    id: 2,
    label: "Bi-Weekly",
  },
  {
    id: 3,
    label: "Monthly",
  },
  // {
  //   id: 4,
  //   label: "Bi-Monthly",
  // },
  {
    id: 4,
    label: "Semi-Monthly",
  },
  {
    id: 5,
    label: "Custom",
  },
];

export const weekDays = [
  { label: "Monday" },
  { label: "Tuesday" },
  { label: "Wednesday" },
  { label: "Thursday" },
  { label: "Friday" },
  { label: "Saturday" },
  { label: "Sunday" },
];

export const days_of_week2 = [
  { label: "Sunday" },
  { label: "Monday" },
  { label: "Tuesday" },
  { label: "Wednesday" },
  { label: "Thursday" },
  { label: "Friday" },
  { label: "Saturday" },
];

export const GroupEmployee = [
  {
    name: "Employee name",
    key: "employee_name",
  },
  {
    name: "Employee id",
    key: "employee_id",
  },
  {
    name: "Paid days",
    key: "paid_days",
  },
  {
    name: "Grosses Pay",
    key: "gross_pay",
  },
  {
    name: "Deduction",
    key: "deduction",
  },
  {
    name: "Net Salary",
    key: "net_salary",
  },
  {
    name: "Add. Deduction",
    key: "additional_deduction",
  },
  {
    name: "Net Pay",
    key: "net_pay",
  },
];

export const payRunTableHeader = [
  {
    name: "Payrun Name",
    key: "name",
  },
  {
    name: "Start Date",
    key: "start_date",
  },
  {
    name: "End Date",
    key: "end_date",
  },
  {
    name: "Number of Employee",
    key: "num_of_employees",
  },
  {
    name: "Pay Date",
    key: "run_date",
  },
  {
    name: "Group count",
    key: "group_count",
  },
  {
    name: "Status",
    key: "status",
  },
];

export const payrunCycleTableFilterKeys = [
  "pay_run_cycle_type",
  "date_of_month",
  "day_of_week",
  "payment_basis",
  "name",
];

export const EmployeeBankDetailsHeader = [
  {
    name: "Employee",
    key: "user_name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Employee Id",
    key: "employee_id",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },

  {
    name: "Department",
    key: "department_name",
    type: "string",
    icon: <People fontSize="small" />,
  },

  {
    name: "Account Holder Name",
    key: "account_holder_name",
    type: "string",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Account No",
    key: "account_no",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Bank Name",
    key: "bank_name",
    type: "string",
    icon: <Dns fontSize="small" />,
  },
  {
    name: "Bank Branch",
    key: "branch_name",
    type: "string",
    icon: <AddHome fontSize="small" />,
  },
  {
    name: "IFSC",
    key: "ifsc",
    type: "string",
    icon: <BrandingWatermark fontSize="small" />,
  },
  {
    name: "Amount",
    key: "net_pay",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
];

export const incentiveType = [
  {
    label: "Attendance",
  },
  {
    label: "OverTime",
  },
  {
    label: "Custom",
  },
];

export const IncentiveEmployeeDetails = [
  {
    name: "Employee Name",
    key: "employee_name",
  },
  {
    name: "Type",
    key: "incentive_type",
  },
  {
    name: "Date Range",
    key: "{start_date}-{end_date}",
  },
  {
    name: "Amount",
    key: "incentive_amount",
  },
  {
    name: "Status",
    key: "status",
  },
  {
    name: "Payrun",
    key: "payrun_month",
  },
  {
    name: "Action",
    key: "action",
  },
];

// updated design

export const earningShiftHeader = [
  {
    name: "Employee",
    key: "employee",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },
  { name: "Department", key: "department", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  {
    name: "Date",
    key: "date",
    type: "date",
    customFormatter: (item) => exportDate(item.date),
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  // "employee" is built by the Shift Earnings screen as "<name> (<code>)",
  // so search, filter and downloads cover both; the table shows the code
  // under the name.
  {
    name: "Day Type",
    key: "earning_type",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
  {
    name: "Shift",
    key: "shift_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Working Hrs",
    key: "worked_shift_hours",
    type: "time",
    icon: <Timer fontSize="small" />,
    showBetweenOperator: false,
  },

  {
    name: "Basis",
    key: "basis",
    type: "autocomplete",
    icon: <HistoryToggleOff fontSize="small" />,
    showBetweenOperator: false,
  },
  // Same order as the view panel's calculation:
  // Credited - Penalty = Net Qty, Net Qty x Factor = Payable Qty,
  // Payable Qty x Rate = Payable.
  {
    name: "Credited Qty",
    key: "quantity",
    type: "number",
    icon: <FilterTiltShift fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Penalty Qty",
    key: "penalty",
    type: "number",
    icon: <Badge fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Net Qty",
    key: "net",
    type: "number",
    icon: <Payments fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Factor",
    key: "payment_factor",
    type: "number",
    icon: <Bolt fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Payable Qty",
    key: "adjusted",
    type: "number",
    icon: <Badge fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Rate",
    key: "rate",
    type: "number",
    icon: <Payments fontSize="small" />,
    showBetweenOperator: false,
  },
  // API display fields are normalized by ShiftEarnings/shiftEarningsApi.js.
  {
    name: "Payable",
    key: "payable_amount",
    type: "number",
    icon: <Payments fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Payroll Cycle",
    key: "payroll_cycle",
    type: "string",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Source",
    key: "source",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
  // Approval status from the API (Pending / Approved / Rejected).
  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
];

// Pay Inputs > Leave (TblPayrollLeaveEarning). Same shape as
// earningShiftHeader without the attendance-only columns, plus Rate.
export const earningLeaveHeader = [
  {
    name: "Employee",
    key: "employee",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },
  { name: "Department", key: "department", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  {
    name: "Date",
    key: "date",
    type: "date",
    customFormatter: (item) => exportDate(item.date),
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  // "employee" is built by the Leave screen as "<name> (<code>)".
  {
    name: "Leave Type",
    key: "earning_type",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
  {
    name: "Shift",
    key: "shift_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },

  {
    name: "Basis",
    key: "basis",
    type: "autocomplete",
    icon: <HistoryToggleOff fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Credited Qty",
    key: "quantity",
    type: "number",
    icon: <FilterTiltShift fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Rate",
    key: "rate",
    type: "number",
    icon: <Payments fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Factor",
    key: "payment_factor",
    type: "number",
    icon: <Bolt fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Payable",
    key: "payable_amount",
    type: "number",
    icon: <Payments fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Payroll Cycle",
    key: "payroll_cycle",
    type: "string",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Source",
    key: "source",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
  // Approval status from the API (Pending / Approved / Rejected).
  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
];

// Pay Inputs > Penalties (TblPayrollDailyPenalty). Same shape as
// earningLeaveHeader; Penalty Qty is text (shifts, HH:MM or an amount).
export const penaltyHeader = [
  {
    name: "Employee",
    key: "employee",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },
  { name: "Department", key: "department", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  {
    name: "Date",
    key: "date",
    type: "date",
    customFormatter: (item) => exportDate(item.date),
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  // "employee" is built by the Penalties screen as "<name> (<code>)".
  {
    name: "Penalty Type",
    key: "penalty_type",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
  {
    name: "Shift",
    key: "shift_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },

  {
    name: "Basis",
    key: "basis",
    type: "autocomplete",
    icon: <HistoryToggleOff fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Penalty Qty",
    key: "quantity",
    type: "string",
    icon: <FilterTiltShift fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Rate",
    key: "rate",
    type: "number",
    icon: <Payments fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Factor",
    key: "payment_factor",
    type: "number",
    icon: <Bolt fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Penalty Amount",
    key: "payable_amount",
    type: "number",
    icon: <Payments fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Payroll Cycle",
    key: "payroll_cycle",
    type: "string",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Source",
    key: "source",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
  // Approval status from the API (Pending / Approved / Rejected).
  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
];

// Pay Inputs > Overtime (sample data in Overtime/overtimeData.js). Same
// shape as earningShiftHeader, with OT Hrs and Rate instead of Shift.
export const earningOvertimeHeader = [
  {
    name: "Employee",
    key: "employee",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },
  { name: "Department", key: "department", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  {
    name: "Date",
    key: "date",
    type: "date",
    customFormatter: (item) => exportDate(item.date),
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  // "employee" is built by the Overtime screen as "<name> (<code>)".
  {
    name: "OT Band",
    key: "band_name",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
  {
    name: "Working Hrs",
    key: "worked_hours",
    type: "time",
    icon: <Timer fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Basis",
    key: "basis",
    type: "autocomplete",
    icon: <HistoryToggleOff fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Credited Qty",
    key: "quantity",
    type: "number",
    icon: <FilterTiltShift fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Factor",
    key: "payment_factor",
    type: "number",
    icon: <Bolt fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Rate",
    key: "rate",
    type: "number",
    icon: <Payments fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Payable",
    key: "payable_amount",
    type: "number",
    icon: <Payments fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Payroll Cycle",
    key: "payroll_cycle",
    type: "string",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Source",
    key: "source",
    type: "autocomplete",
    icon: <ViewWeek fontSize="small" />,
  },
  { name: "Status", key: "status", type: "autocomplete", icon: <HistoryToggleOff fontSize="small" /> },
];

export const deductionsPenaltiesHeader = [
  {
    name: "Date",
    key: "date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    name: "Emp ID",
    key: "employee_code",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Emp Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Penalty type",
    key: "penalty_type",
    type: "autocomplete",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Deviation Duration",
    key: "deficit_hrs",
    type: "time",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Penalty Basis",
    key: "basis",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Penalty",
    key: "penalty",
    type: "number",
    icon: <AccessTime fontSize="small" />,
    showBetweenOperator: false,
  },
  {
    name: "Adjustment Basis",
    key: "adjuted_basis",
    type: "number",
    icon: <Update fontSize="small" />,
  },
  {
    name: "Penalty Qty",
    key: "adjusted",
    type: "number",
    icon: <Paid fontSize="small" />,
  },
  {
    name: "Penalty Amount",
    key: "penalty_amount",
    type: "number",
    icon: <AvTimer fontSize="small" />,
  },
  {
    name: "Action",
    key: "action",
  },
];

export const dailyPayrunHeaders = [
  { name: "Date", key: "date" },
  { name: "Emp ID", key: "employee_code" },
  { name: "Emp Name", key: "employee_name" },
  { name: "Department", key: "department_name" },
  { name: "Day Type", key: "day_type" },
  {
    name: "Regular Pay",
    children: [
      { name: "Pay Basis", key: "earning_basis" },
      { name: "Worked Qty", key: "earning_qty" },
      { name: "Rate", key: "earning_rate" },
      { name: "Amount", key: "earning_amount" },
    ],
  },
  {
    name: "Overtime",
    children: [
      { name: "OT Basis", key: "ot_basis" },
      { name: "OT Qty", key: "ot_qty" },
      { name: "Rate", key: "ot_rate" },
      { name: "Amount", key: "ot_amount" },
    ],
  },
  { name: "Total", key: "net_salary" },
];

export const operationsDailyPayrunHeader = [
  {
    name: "Date",
    key: "date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "date",
      toField: "date",
    },
  },
  {
    name: "Emp Id",
    key: "employee_code",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Emp Name",
    key: "employee_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Department",
    key: "department_name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Day type",
    key: "day_type",
    type: "autocomplete",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Pay basis",
    key: "earning_basis",
    type: "autocomplete",
    icon: <FilterTiltShift fontSize="small" />,
  },
  {
    name: "Worked Qty",
    key: "earning_qty",
    type: "number",
    icon: <PunchClock fontSize="small" />,
  },
  {
    name: "Rate",
    key: "earning_rate",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Amount",
    key: "earning_amount",
    type: "number",
    icon: <Paid fontSize="small" />,
  },
  {
    name: "OT Basis",
    key: "ot_basis",
    type: "number",
    icon: <Update fontSize="small" />,
  },
  {
    name: "OT Qty",
    key: "ot_qty",
    type: "number",
    icon: <HourglassBottom fontSize="small" />,
  },
  {
    name: "Amount",
    key: "ot_amount",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Total",
    key: "net_salary",
    type: "number",
    icon: <Functions fontSize="small" />,
  },
];

export const payrunCycleHeader = [
  {
    name: "Pay Cycle",
    key: "pay_run_cycle_type",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Start Day",
    key: "start_day",
    type: "string",
    icon: <Workspaces fontSize="small" />,
    customFormatter: (item) => {
      return item?.pay_run_cycle_type === "Monthly"
        ? (item?.date_of_month ?? "N/A")
        : (item?.start_day ?? "N/A");
    },
  },
  {
    name: "Starts On",
    key: "start_date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "start_date",
      toField: "start_date",
    },
  },

  {
    name: "Next Run Date",
    key: "next_pay_run_date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "next_pay_run_date",
      toField: "next_pay_run_date",
    },
  },
  {
    name: "Calc based on",
    key: "payment_basis",
    type: "autocomplete",
    icon: <Payments fontSize="small" />,
  },

  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <MilitaryTech fontSize="small" />,
  },

  {
    name: "Payrun Cycle Name",
    key: "name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
];

export const PaycycleHistoryHeader = [
  {
    name: "Payrun Name",
    key: "pay_run_cycle_name",
  },
  {
    name: "Start Date",
    key: "start_date",
  },
  {
    name: "End Date",
    key: "end_date",
  },
  {
    name: "Group Count",
    key: "group_count",
  },
  {
    name: "No of Employees",
    key: "no_of_employees",
  },
  {
    name: "Status",
    key: "status",
  },
];

export const paymentBankHeader = [
  {
    name: "Bank Name",
    key: "bank_name",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Nick Name",
    key: "nick_name",
    type: "autocomplete",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Account Number",
    key: "bank_account_number",
    type: "number",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Branch",
    key: "bank_branch",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "IFSC Code",
    key: "bank_ifsc_code",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
];

export const payrollGroupHeader = [
  {
    name: "Payroll Group Name",
    key: "name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Payrun Cycle",
    key: "pay_run_cycle_name",
    type: "string",
    icon: <Workspaces fontSize="small" />,
  },
  {
    name: "Payment Bank",
    key: "source_bank_detail_name",
    type: "autocomplete",
    icon: <DateRange fontSize="small" />,
  },
  {
    name: "Payment Mode",
    key: "mode_of_payment",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Employee Count",
    key: "users_count",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
];

export const payrollCycleHeader = [
  {
    name: "Payrun name",
    key: "name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Start date",
    key: "start_date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "start_date",
      toField: "end_date",
    },
  },
  {
    name: "End date",
    key: "end_date",
    type: "autocomplete",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "start_date",
      toField: "end_date",
    },
  },
  {
    name: "No of employee",
    key: "no_of_employees",
    type: "number",
    icon: <AccountCircle fontSize="small" />,
  },
  {
    name: "Pay date",
    key: "run_date",
    type: "number",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "run_date",
      toField: "run_date",
    },
  },
  {
    name: "Group Count",
    key: "group_count",
    type: "number",
    icon: <People fontSize="small" />,
  },
  {
    name: "Basis",
    key: "payment_basis",
    type: "autocomplete",
    icon: <SportsBaseball fontSize="small" />,
  },
  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <MilitaryTech fontSize="small" />,
  },
];

export const upcomingPayrollCycleHeader = [
  {
    name: "Payrun name",
    key: "name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Start date",
    key: "start_date",
    type: "date",
    icon: <Workspaces fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "start_date",
      toField: "end_date",
    },
  },
  {
    name: "End date",
    key: "end_date",
    type: "date",
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "start_date",
      toField: "end_date",
    },
  },
  {
    name: "No of employee",
    key: "no_of_employees",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Pay date",
    key: "run_date",
    type: "date",
    icon: <Badge fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: {
      fromField: "run_date",
      toField: "run_date",
    },
  },
  {
    name: "Group Count",
    key: "group_count",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Basis",
    key: "payment_basis",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Status",
    key: "status",
    type: "autocomplete",
    icon: <Badge fontSize="small" />,
  },
];

export const payrunEmployeeHeader = [
  {
    name: "Employee Name",
    key: "employee_name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Employee Id",
    key: "employee_id",
    type: "string",
    icon: <PermIdentity fontSize="small" />,
  },
  {
    name: "Paid Days",
    key: "paid_days",
    type: "number",
    icon: <CalendarViewWeek fontSize="small" />,
  },
  {
    name: "Gross Pay",
    key: "gross_pay",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Deduction",
    key: "deduction",
    type: "number",
    icon: <RemoveCircleOutline fontSize="small" />,
  },
  {
    name: "Net Salary",
    key: "net_salary",
    type: "number",
    icon: <MonetizationOn fontSize="small" />,
  },
  {
    name: "Add. Deduction",
    key: "additional_deduction",
    type: "number",
    icon: <RemoveCircleOutline fontSize="small" />,
  },
  {
    name: "Net Pay",
    key: "net_pay",
    type: "number",
    icon: <Paid fontSize="small" />,
  },
  {
    name: "Action",
    key: "Action",
  },
];

export const runPayrollGroupHeaders = [
  {
    name: "Group name",
    key: "name",
    type: "string",
    icon: <PeopleAlt fontSize="small" />,
  },
  {
    name: "No. of Emp",
    key: "no_of_employee",
    type: "number",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Payment Bank",
    key: "payment_bank",
    type: "autocomplete",
    icon: <AccountBalance fontSize="small" />,
  },
  {
    name: "Payment Mode",
    key: "payment_mode",
    type: "autocomplete",
    icon: <Source fontSize="small" />,
  },
  {
    name: "Payroll cost",
    key: "payroll_cost",
    type: "number",
    icon: <AddCard fontSize="small" />,
  },
  {
    name: "Total Deduction",
    key: "total_deduction",
    type: "number",
    icon: <RemoveCircleOutline fontSize="small" />,
  },
  {
    name: "Group net salary",
    key: "group_net_salary",
    type: "number",
    icon: <MonetizationOn fontSize="small" />,
  },
  {
    name: "Additional deduction",
    key: "additional_deduction",
    type: "number",
    icon: <RemoveCircleOutline fontSize="small" />,
  },
  {
    name: "Net pay",
    key: "net_pay",
    type: "number",
    icon: <Paid fontSize="small" />,
  },
  {
    name: "Action",
    key: "Action",
  },
];

export const payrollGroupEmployeeHeader = [
  {
    name: "Employee Id",
    key: "employee_id",
  },
  {
    name: "Employee Name",
    key: "username",
  },

  {
    name: "Action",
    key: "action",
  },
];

export const paymentOptions = [
  {
    id: "Shift",
    label: "Shift",
    description:
      "Calculate pay based on the number of adjusted shifts during the payroll period",
  },
  {
    id: "Hours",
    label: "Hours",
    description:
      "Calculate pay based on the total adjusted working hours in the payroll period",
  },
];

export const earningTypeColors = {
  "Shift Earning": { bg: "#1abc9c", color: "#fff" },
  "Paid Week Off": { bg: "#d35400", color: "#fff" },
  "Paid Leave": { bg: "#9b59b6", color: "#fff" },
  "Company Leave Attendance": { bg: "#9b59b6", color: "#fff" },
  "Paid Company Leave": { bg: "#D1D16B", color: "#000" },
  Holilday: { bg: "#4c9d97", color: "#fff" },
  Absent: { bg: "#ff6666", color: "#fff" },
};

export const penaltyTypeColors = {
  "Absent Deductions": { bg: "#1abc9c", color: "#fff" },
  "Late Early": { bg: "#d35400", color: "#fff" },
  "Early Exit": { bg: "#9b59b6", color: "#fff" },
  "Break Penalty": { bg: "#9b59b6", color: "#fff" },
  Absent: { bg: "#ff6666", color: "#fff" },
};

export const dailyPayrunColors = {
  Holilday: { bg: "#4c9d97", color: "#fff" },
  "Break penality": { bg: "#ddbbd4", color: "#fff" },
  "Week Day": { bg: "#88D8B3", color: "#000" },
  "Weekoff Attendance": { bg: "#a7bfec", color: "#000" },
  Absent: { bg: "#ff6666", color: "#fff" },
  "Paid Company Leave": { bg: "#D1D16B", color: "#000" },
};

export const weekDaysName = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export const legendData = [
  { label: "Present", code: "P", color: "#3A8D4C" },
  { label: "Absent", code: "A", color: "#DE4646" },
  { label: "Shift Planned", code: "SP", color: "#F675FF" },
  { label: "Unassigned", code: "UA", color: "#87CEEB" },
  { label: "Late Entry", code: "LE", color: "#DBA6FFD5" },
  { label: "Early Exit", code: "EE", color: "#E1FF77AC" },
  { label: "Overtime", code: "OT", color: "#F5E9E8" },
  { label: "Missing", code: "M", color: "#FF9169" },
  { label: "Week Off", code: "W", color: "#D3FCFC" },
  { label: "Permission", code: "PR", color: "#171D1A" },
  { label: "Leave", code: "L", color: "#D3A500" },
  { label: "Half Day Leave", code: "HL", color: "#6B3E3E" },
  { label: "Holiday", code: "H", color: "#9D97FAFF" },
  { label: "Not Joined", code: "NJ", color: "#808080" },
];

export const DailyPayrunAmountDateView = [
  { name: "", key: "" },
  { name: "Date", key: "date" },
  {
    name: "Regular Pay",
    children: [
      { name: "No of Employee", key: "shift_no_employee" },
      { name: "Amount", key: "earning_amount" },
    ],
  },
  {
    name: "Overtime",
    children: [
      { name: "No of Employee", key: "ot_no_employee" },
      { name: "Amount", key: "ot_amount" },
    ],
  },
  { name: "Total", key: "total_amount" },
];

export const expandHearder = [
  { name: "Date", key: "date" },
  { name: "Payschedule", key: "payschedule_name" },
  { name: "PayCycleEmployee", key: "no_cycle_employee" },
  { name: "DailyPayrunEmployee", key: "no_daily_payrun" },
  {
    name: "Regular Pay",
    children: [
      { name: "No of Employee", key: "shift_no_employee" },
      { name: "Amount", key: "earning_amount" },
    ],
  },
  {
    name: "Overtime",
    children: [
      { name: "No of Employee", key: "ot_no_employee" },
      { name: "Amount", key: "ot_amount" },
    ],
  },
  { name: "Total", key: "total_amount" },
];

export const incentiveHeaders = [
  {
    key: "expand",
    name: "",
  },
  {
    name: "Name",
    key: "incentive_template_name",
    type: "string",
    icon: <Badge fontSize="small" />,
  },
  {
    name: "Start date",
    key: "start_date",
    type: "date",
    icon: <CalendarMonth fontSize="small" />,
  },
  {
    name: "End date",
    key: "end_date",
    type: "date",
    icon: <CalendarMonth fontSize="small" />,
  },
  {
    name: "Payrun",
    key: "payroll_schedule_name",
    type: "string",
    icon: <Timeline fontSize="small" />,
  },
  {
    name: "No. of Employee",
    key: "qualified_count",
    type: "number",
    icon: <Groups fontSize="small" />,
  },
  {
    name: "Amount",
    key: "total_incentive_amount",
    type: "number",
    icon: <Payments fontSize="small" />,
  },
  {
    name: "Status",
    key: "status",
    type: "string",
    icon: <HourglassTop fontSize="small" />,
  },
];

export const payrollAwaitingHeaders = [
  {
    name: "Payrun name",
    key: "payroll_schedule_name",
    type: "string",
    icon: <EventNote fontSize="small" />,
  },
  {
    name: "Start date",
    key: "start_date",
    type: "date",
    icon: <CalendarMonth fontSize="small" />,
  },
  {
    name: "End date",
    key: "end_date",
    type: "date",
    icon: <CalendarMonth fontSize="small" />,
  },
  {
    name: "No of Employee",
    key: "qualified_count",
    type: "number",
    icon: <Groups fontSize="small" />,
  },
  {
    name: "Pay date",
    key: "pay_date",
    type: "date",
    icon: <EventAvailable fontSize="small" />,
  },
  {
    name: "Group count",
    key: "group_count",
    type: "number",
    icon: <GroupWork fontSize="small" />,
  },
  {
    name: "Status",
    key: "status",
    type: "string",
    icon: <HourglassBottom fontSize="small" />,
  },
];

export const payrollCompletedHeaders = [
  {
    name: "Payrun name",
    key: "payroll_schedule_name",
    type: "string",
    icon: <EventNote fontSize="small" />,
  },
  {
    name: "Start date",
    key: "start_date",
    type: "date",
    icon: <CalendarMonth fontSize="small" />,
  },
  {
    name: "End date",
    key: "end_date",
    type: "date",
    icon: <CalendarMonth fontSize="small" />,
  },
  {
    name: "No of Employee",
    key: "qualified_count",
    type: "number",
    icon: <Groups fontSize="small" />,
  },
  {
    name: "Pay date",
    key: "pay_date",
    type: "date",
    icon: <EventAvailable fontSize="small" />,
  },
  {
    name: "Group count",
    key: "group_count",
    type: "number",
    icon: <GroupWork fontSize="small" />,
  },
  {
    name: "Status",
    key: "status",
    type: "string",
    icon: <CheckCircle fontSize="small" />,
  },
];

export const eligibleEmployee = [
  {
    name: "Employee Id",
    key: "employee_id",
    type: "string",
    icon: <EventNote fontSize="small" />,
  },
  {
    name: "Name",
    key: "name",
    type: "string",
    icon: <CalendarMonth fontSize="small" />,
  },
  {
    name: "Department",
    key: "department",
    type: "string",
    icon: <CalendarMonth fontSize="small" />,
  },
  {
    name: "Designation",
    key: "designation",
    type: "string",
    icon: <Groups fontSize="small" />,
  },
];

// Payroll > Salary > Salary Components list. "name" also searches the
// description shown under it.
export const salaryComponentListHeader = [
  { name: "Component", key: "name", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Code", key: "code", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "Category", key: "category", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  { name: "Method", key: "method", type: "autocomplete", icon: <Functions fontSize="small" /> },
  { name: "Default value", key: "default_value", type: "string", icon: <Payments fontSize="small" /> },
  { name: "Payslip", key: "payslip", type: "autocomplete", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "Version", key: "version", type: "autocomplete", icon: <Update fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <Source fontSize="small" /> },
];

// Payroll > Salary > Salary Templates list.
export const salaryTemplateListHeader = [
  { name: "Template", key: "name", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Pay basis", key: "pay_basis", type: "autocomplete", icon: <CalendarViewWeek fontSize="small" /> },
  { name: "Components", key: "components", type: "number", icon: <Workspaces fontSize="small" /> },
  { name: "Version", key: "version", type: "autocomplete", icon: <Update fontSize="small" /> },
  { name: "Employees", key: "employees", type: "number", icon: <People fontSize="small" /> },
  { name: "Updates", key: "updates_label", type: "autocomplete", icon: <Bolt fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <Source fontSize="small" /> },
];

// Payroll > Salary > Assign Salary: requests and employees with no salary.
export const assignSalaryRequestHeader = [
  { name: "Request", key: "request", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Payroll group · employees", key: "payroll_group", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  { name: "Gross", key: "gross", type: "number", icon: <Payments fontSize="small" /> },
  { name: "Effective from", key: "effective", type: "string", icon: <DateRange fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <Source fontSize="small" /> },
];

export const assignSalaryPendingHeader = [
  { name: "Employee", key: "name", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Department", key: "department", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  { name: "Position", key: "position", type: "autocomplete", icon: <ManageAccounts fontSize="small" /> },
  { name: "Joined", key: "joined_label", type: "string", icon: <DateRange fontSize="small" /> },
  { name: "Waiting", key: "waiting", type: "number", icon: <HourglassBottom fontSize="small" /> },
];

// Payroll > Salary > Salary Revision list.
export const salaryRevisionListHeader = [
  { name: "Revision", key: "revision", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Change", key: "change", type: "autocomplete", icon: <Update fontSize="small" /> },
  { name: "Gross", key: "gross", type: "number", icon: <Payments fontSize="small" /> },
  { name: "Effective from", key: "effective", type: "string", icon: <DateRange fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <Source fontSize="small" /> },
];

// Payroll > Salary > Employee Salary list.
export const employeeSalaryListHeader = [
  { name: "Employee", key: "name", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Department", key: "department", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  { name: "Payroll group", key: "payroll_group", type: "autocomplete", icon: <Apartment fontSize="small" /> },
  { name: "Template", key: "template", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Gross", key: "gross", type: "number", icon: <Payments fontSize="small" /> },
  { name: "Effective from", key: "effective_label", type: "string", icon: <DateRange fontSize="small" /> },
  { name: "Last change", key: "last_change", type: "autocomplete", icon: <Update fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <ConfirmationNumber fontSize="small" /> },
];

// Pay Inputs > Loans & Advances (advance request API, LoansAndAdvances/loansApi.js).
// "employee" is built by the screen as "<name> (<code>)".
export const loanAdvanceHeader = [
  { name: "Employee", key: "employee", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  { name: "Department", key: "department", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  {
    name: "Issue Date",
    key: "issue_date",
    type: "date",
    customFormatter: (item) => exportDate(item.issue_date),
    icon: <DateRange fontSize="small" />,
    showBetweenOperator: true,
    dateRangeFields: { fromField: "issue_date", toField: "issue_date" },
  },
  { name: "Record Type", key: "record_type", type: "autocomplete", icon: <ViewWeek fontSize="small" /> },
  { name: "Source", key: "source", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Description / Reference", key: "description", type: "string", icon: <CreditCard fontSize="small" /> },
  { name: "Reason", key: "reason", type: "string", icon: <CreditCard fontSize="small" /> },
  { name: "Disbursed Amount", key: "disbursed_amount", type: "number", icon: <Payments fontSize="small" />, showBetweenOperator: false },
  { name: "Repaid", key: "repaid_amount", type: "number", icon: <Savings fontSize="small" />, showBetweenOperator: false },
  { name: "Outstanding Amount", key: "outstanding_amount", type: "number", icon: <AccountBalance fontSize="small" />, showBetweenOperator: false },
  { name: "Repayment Progress", key: "progress_label", type: "string", icon: <Update fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <ConfirmationNumber fontSize="small" /> },
];

// Payroll > Configuration > Statutory > PF > Establishment Codes.
export const pfEstablishmentCodeHeader = [
  { name: "Establishment Code", key: "code", type: "string", icon: <Dns fontSize="small" /> },
  { name: "Type", key: "type_label", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  { name: "Main Code", key: "main_code_label", type: "string", icon: <Dns fontSize="small" /> },
  { name: "Branch / Name", key: "branch_name", type: "string", icon: <Apartment fontSize="small" /> },
  { name: "EPFO Office", key: "epfo_office", type: "autocomplete", icon: <AccountBalance fontSize="small" /> },
  { name: "Sites Covered", key: "sites_label", type: "string", icon: <AddHome fontSize="small" /> },
  { name: "PF Members", key: "members", type: "number", icon: <Groups fontSize="small" />, align: "right" },
  { name: "Coverage From", key: "coverage_from", type: "date", icon: <DateRange fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <ConfirmationNumber fontSize="small" /> },
];

// Payroll > Configuration > Statutory > PF > Exit Codes.
export const pfExitCodeHeader = [
  { name: "Code", key: "code", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "EPFO Reason", key: "label", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Mapped Cauver Exit Reasons", key: "reasons_label", type: "string", icon: <People fontSize="small" /> },
  { name: "Date of Exit Required", key: "date_required", type: "autocomplete", icon: <DateRange fontSize="small" /> },
  { name: "Date Used", key: "date_used", type: "autocomplete", icon: <Update fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <ConfirmationNumber fontSize="small" /> },
];

// Payroll > Configuration > Statutory > ESI > Employer Codes.
export const esiEmployerCodeHeader = [
  { name: "ESI Code", key: "code", type: "string", icon: <Dns fontSize="small" /> },
  { name: "Type", key: "type_label", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  { name: "Main Code", key: "main_code_label", type: "string", icon: <Dns fontSize="small" /> },
  { name: "Branch / Name", key: "branch_name", type: "string", icon: <Apartment fontSize="small" /> },
  { name: "Sites", key: "locations_label", type: "string", icon: <AddHome fontSize="small" /> },
  { name: "Employees", key: "employees", type: "number", icon: <Groups fontSize="small" />, align: "right" },
  { name: "Coverage From", key: "coverage_from", type: "date", icon: <DateRange fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <ConfirmationNumber fontSize="small" /> },
];

// Payroll > Configuration > Statutory > ESI > Reason Codes.
export const esiReasonCodeHeader = [
  { name: "Code", key: "code", type: "number", icon: <Dns fontSize="small" /> },
  { name: "ESIC Reason", key: "label", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Mapped Cauver Reasons", key: "reasons_label", type: "string", icon: <People fontSize="small" /> },
  { name: "Last Working Day", key: "lwd_label", type: "autocomplete", icon: <DateRange fontSize="small" /> },
  { name: "Removed from Portal Record", key: "removes_label", type: "autocomplete", icon: <Update fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <ConfirmationNumber fontSize="small" /> },
];

// Payroll > Statutory > ESI > Eligibility.
export const esiEligibilityHeader = [
  { name: "Name", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Department", key: "department", type: "autocomplete", icon: <Apartment fontSize="small" /> },
  { name: "ESI Code", key: "code_label", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "IP Number", key: "ip_label", type: "string", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "Wage at Period Start (₹)", key: "wage_at_test", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "Coverage", key: "coverage_label", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Covered Until", key: "covered_until_label", type: "string", icon: <DateRange fontSize="small" /> },
  { name: "IP Status", key: "ip_status", type: "autocomplete", icon: <AccountBalance fontSize="small" /> },
];

// Payroll > Reports > Statutory Reports > ESI > Contribution Register.
export const esiRegisterHeader = [
  { name: "Name", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Department", key: "department", type: "autocomplete", icon: <Apartment fontSize="small" /> },
  { name: "ESI Code", key: "code_label", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "IP Number", key: "ip_label", type: "string", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "Days Paid", key: "days", type: "number", icon: <DateRange fontSize="small" />, align: "right" },
  { name: "ESI Wages (₹)", key: "wage", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "Employee (₹)", key: "ee", type: "number", icon: <Paid fontSize="small" />, align: "right" },
  { name: "Employer (₹)", key: "er", type: "number", icon: <AccountBalance fontSize="small" />, align: "right" },
  { name: "Total (₹)", key: "total", type: "number", icon: <Functions fontSize="small" />, align: "right" },
];

// Payroll > Reports > Statutory Reports > ESI > Reconciliation.
export const esiReconciliationHeader = [
  { name: "Month", key: "month_label", type: "autocomplete", icon: <DateRange fontSize="small" /> },
  { name: "ESI Code", key: "code_label", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "Liability (₹)", key: "liability_total", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "Challan (₹)", key: "paid", type: "number", icon: <Paid fontSize="small" />, align: "right" },
  { name: "Paid On", key: "paid_on", type: "date", icon: <DateRange fontSize="small" /> },
  { name: "Reference", key: "reference", type: "string", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Action", key: "action", type: "string", icon: <Bolt fontSize="small" /> },
];

// Payroll > Reports > Statutory Reports > ESI > Validation.
export const esiValidationHeader = [
  { name: "Name", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "ESI Code", key: "code_label", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "Issue", key: "issue", type: "string", icon: <Source fontSize="small" /> },
  { name: "Severity", key: "severity", type: "autocomplete", icon: <Bolt fontSize="small" /> },
  { name: "Fix in", key: "fix_in", type: "autocomplete", icon: <ManageAccounts fontSize="small" /> },
];

// Payroll > Statutory > PF > Members.
export const pfMemberHeader = [
  { name: "Name", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Department", key: "department", type: "autocomplete", icon: <Apartment fontSize="small" /> },
  { name: "PF Code", key: "pf_code_label", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "UAN", key: "uan_label", type: "string", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "Date of Birth (Age)", key: "dob_label", type: "string", icon: <DateRange fontSize="small" /> },
  { name: "PF Wage (₹)", key: "pf_wage", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "PF Status", key: "status", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Pension (EPS)", key: "pension_label", type: "autocomplete", icon: <AccountBalance fontSize="small" /> },
  { name: "Extra PF", key: "extra_label", type: "string", icon: <AddCard fontSize="small" /> },
];

// Payroll > Reports > Statutory Reports > PF > Contribution Register.
export const pfRegisterHeader = [
  { name: "Name", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "UAN", key: "uan_label", type: "string", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "PF Code", key: "code_label", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "Unpaid Days", key: "unpaid_days", type: "number", icon: <DateRange fontSize="small" />, align: "right" },
  { name: "PF Wage (₹)", key: "epf_wage", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "Pension Wage (₹)", key: "eps_wage", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "Employee PF (₹)", key: "ee_pf", type: "number", icon: <Paid fontSize="small" />, align: "right" },
  { name: "Extra PF (₹)", key: "vpf", type: "number", icon: <AddCard fontSize="small" />, align: "right" },
  { name: "Pension (₹)", key: "er_eps", type: "number", icon: <AccountBalance fontSize="small" />, align: "right" },
  { name: "Employer PF (₹)", key: "er_epf", type: "number", icon: <Paid fontSize="small" />, align: "right" },
  { name: "PF Total (₹)", key: "total", type: "number", icon: <Functions fontSize="small" />, align: "right" },
];

// Payroll > Reports > Statutory Reports > PF > Exits.
export const pfExitsHeader = [
  { name: "Name", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "UAN", key: "uan", type: "string", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "PF Code", key: "code_label", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "Joined PF", key: "joined_pf", type: "date", icon: <DateRange fontSize="small" /> },
  { name: "Date of Exit", key: "exit_date", type: "date", icon: <DateRange fontSize="small" /> },
  { name: "Exit Reason", key: "reason_label", type: "autocomplete", icon: <People fontSize="small" /> },
  { name: "EPFO Code", key: "epfo_label", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <Source fontSize="small" /> },
];

// Payroll > Reports > Statutory Reports > PF > Reconciliation.
export const pfReconciliationHeader = [
  { name: "Month", key: "month_label", type: "autocomplete", icon: <DateRange fontSize="small" /> },
  { name: "PF Code", key: "code_label", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "Payable (₹)", key: "payable", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "Paid (₹)", key: "paid", type: "number", icon: <Paid fontSize="small" />, align: "right" },
  { name: "TRRN", key: "trrn", type: "string", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "Paid On", key: "paid_on", type: "date", icon: <DateRange fontSize="small" /> },
  { name: "Status", key: "status", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Action", key: "action", type: "string", icon: <Bolt fontSize="small" /> },
];

// Payroll > Reports > Statutory Reports > PF > Validation.
export const pfValidationHeader = [
  { name: "Name", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "PF Code", key: "code_label", type: "autocomplete", icon: <Dns fontSize="small" /> },
  { name: "Issue", key: "issue", type: "string", icon: <Source fontSize="small" /> },
  { name: "Severity", key: "severity", type: "autocomplete", icon: <Bolt fontSize="small" /> },
  { name: "Affects", key: "affects", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  { name: "Fix in", key: "fix_in", type: "autocomplete", icon: <ManageAccounts fontSize="small" /> },
];

// Payroll > Configuration > Statutory > Labour Welfare Fund (sites).
export const lwfSiteHeader = [
  { name: "Site", key: "site", type: "string", icon: <Apartment fontSize="small" /> },
  { name: "State", key: "state", type: "autocomplete", icon: <AddHome fontSize="small" /> },
  { name: "LWF Registration No.", key: "registration_no", type: "string", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "Deducted", key: "frequency_label", type: "autocomplete", icon: <Update fontSize="small" /> },
  { name: "Deduct In", key: "deduct_in_label", type: "autocomplete", icon: <DateRange fontSize="small" /> },
  { name: "Current Version", key: "version_label", type: "string", icon: <Dns fontSize="small" /> },
  { name: "Effective From", key: "effective_from", type: "date", icon: <DateRange fontSize="small" /> },
  { name: "Status", key: "status_label", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Action", key: "action", type: "string", icon: <Bolt fontSize="small" /> },
];

// Payroll > Statutory > Labour Welfare Fund > Employees.
export const lwfEmployeeHeader = [
  { name: "Name", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Department", key: "department", type: "autocomplete", icon: <Apartment fontSize="small" /> },
  { name: "LWF Site", key: "site_name", type: "autocomplete", icon: <AddHome fontSize="small" /> },
  { name: "Category", key: "category_label", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  { name: "LWF Wage (₹ / month)", key: "lwf_wage", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "LWF Status", key: "status_label", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Next Deduction", key: "next_label", type: "autocomplete", icon: <DateRange fontSize="small" /> },
  { name: "Employee (₹)", key: "employee_amount", type: "number", icon: <Paid fontSize="small" />, align: "right" },
  { name: "Employer (₹)", key: "employer_amount", type: "number", icon: <AccountBalance fontSize="small" />, align: "right" },
];

// Payroll > Reports > Statutory Reports > Labour Welfare Fund > LWF Register.
export const lwfRegisterHeader = [
  { name: "Name", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Site", key: "site_name", type: "autocomplete", icon: <AddHome fontSize="small" /> },
  { name: "Category", key: "category_label", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
  { name: "LWF Wage (₹)", key: "lwf_wage", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "Employee (₹)", key: "ee", type: "number", icon: <Paid fontSize="small" />, align: "right" },
  { name: "Employer (₹)", key: "er", type: "number", icon: <AccountBalance fontSize="small" />, align: "right" },
  { name: "Total (₹)", key: "total", type: "number", icon: <Functions fontSize="small" />, align: "right" },
  { name: "Status", key: "status_label", type: "autocomplete", icon: <Source fontSize="small" /> },
];

// Payroll > Reports > Statutory Reports > Labour Welfare Fund > Payments.
export const lwfPaymentHeader = [
  { name: "Year", key: "period_label", type: "autocomplete", icon: <DateRange fontSize="small" /> },
  { name: "Site", key: "site", type: "autocomplete", icon: <AddHome fontSize="small" /> },
  { name: "LWF Registration No.", key: "registration_no", type: "string", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "Employees", key: "employees", type: "number", icon: <Groups fontSize="small" />, align: "right" },
  { name: "Employee (₹)", key: "ee", type: "number", icon: <Paid fontSize="small" />, align: "right" },
  { name: "Employer (₹)", key: "er", type: "number", icon: <AccountBalance fontSize="small" />, align: "right" },
  { name: "Payable (₹)", key: "payable", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "Paid (₹)", key: "paid", type: "number", icon: <Paid fontSize="small" />, align: "right" },
  { name: "Balance (₹)", key: "balance", type: "number", icon: <Functions fontSize="small" />, align: "right" },
  { name: "Due Date", key: "due", type: "date", icon: <DateRange fontSize="small" /> },
  { name: "Status", key: "status_label", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Action", key: "action", type: "string", icon: <Bolt fontSize="small" /> },
];

// Payroll > Reports > Statutory Reports > Labour Welfare Fund > Validation.
export const lwfValidationHeader = [
  { name: "Name / Site", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "LWF Site", key: "site", type: "autocomplete", icon: <AddHome fontSize="small" /> },
  { name: "Issue", key: "issue", type: "string", icon: <Source fontSize="small" /> },
  { name: "Severity", key: "severity", type: "autocomplete", icon: <Bolt fontSize="small" /> },
  { name: "Impact", key: "impact", type: "string", icon: <Workspaces fontSize="small" /> },
  { name: "Fix in", key: "fix_in", type: "autocomplete", icon: <ManageAccounts fontSize="small" /> },
];

// Payroll > Configuration > Statutory > Professional Tax (sites).
export const ptSiteHeader = [
  { name: "Site", key: "site", type: "string", icon: <Apartment fontSize="small" /> },
  { name: "State", key: "state", type: "autocomplete", icon: <AddHome fontSize="small" /> },
  { name: "Local Body", key: "local_body", type: "autocomplete", icon: <AccountBalance fontSize="small" /> },
  { name: "PT Registration No.", key: "registration_no", type: "string", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "Deducted", key: "frequency_label", type: "autocomplete", icon: <Update fontSize="small" /> },
  { name: "Current Version", key: "version_label", type: "string", icon: <Dns fontSize="small" /> },
  { name: "Effective From", key: "effective_from", type: "date", icon: <DateRange fontSize="small" /> },
  { name: "Status", key: "status_label", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Action", key: "action", type: "string", icon: <Bolt fontSize="small" /> },
];

// Payroll > Statutory > Professional Tax > Employees.
export const ptEmployeeHeader = [
  { name: "Name", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Department", key: "department", type: "autocomplete", icon: <Apartment fontSize="small" /> },
  { name: "PT Site", key: "site_name", type: "autocomplete", icon: <AddHome fontSize="small" /> },
  { name: "Deducted", key: "frequency_label", type: "autocomplete", icon: <Update fontSize="small" /> },
  { name: "Date of Birth (Age)", key: "dob_label", type: "string", icon: <DateRange fontSize="small" /> },
  { name: "PT Wage (₹ / month)", key: "pt_wage", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "PT Status", key: "pt_status", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Exemption", key: "exemption_label", type: "autocomplete", icon: <Workspaces fontSize="small" /> },
];

// Payroll > Reports > Statutory Reports > Professional Tax > PT Register.
export const ptRegisterHeader = [
  { name: "Name", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "Site", key: "site_name", type: "autocomplete", icon: <AddHome fontSize="small" /> },
  { name: "How Collected", key: "how_collected", type: "autocomplete", icon: <Update fontSize="small" /> },
  { name: "Monthly Wage (₹)", key: "monthly_wage", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "PT This Month (₹)", key: "pt", type: "number", icon: <Paid fontSize="small" />, align: "right" },
  { name: "PT Collected This Period (₹)", key: "collected", type: "number", icon: <Functions fontSize="small" />, align: "right" },
  { name: "Status", key: "status_label", type: "autocomplete", icon: <Source fontSize="small" /> },
];

// Payroll > Reports > Statutory Reports > Professional Tax > Payments.
export const ptPaymentHeader = [
  { name: "Period", key: "period_label", type: "autocomplete", icon: <DateRange fontSize="small" /> },
  { name: "Site", key: "site", type: "autocomplete", icon: <AddHome fontSize="small" /> },
  { name: "PT Registration No.", key: "registration_no", type: "string", icon: <ConfirmationNumber fontSize="small" /> },
  { name: "Employees", key: "employees", type: "number", icon: <Groups fontSize="small" />, align: "right" },
  { name: "Payable (₹)", key: "payable", type: "number", icon: <Payments fontSize="small" />, align: "right" },
  { name: "Paid (₹)", key: "paid", type: "number", icon: <Paid fontSize="small" />, align: "right" },
  { name: "Balance (₹)", key: "balance", type: "number", icon: <Functions fontSize="small" />, align: "right" },
  { name: "Paid On", key: "paid_on", type: "date", icon: <DateRange fontSize="small" /> },
  { name: "Due Date", key: "due", type: "date", icon: <DateRange fontSize="small" /> },
  { name: "Status", key: "status_label", type: "autocomplete", icon: <Source fontSize="small" /> },
  { name: "Action", key: "action", type: "string", icon: <Bolt fontSize="small" /> },
];

// Payroll > Reports > Statutory Reports > Professional Tax > Validation.
export const ptValidationHeader = [
  { name: "Name / Site", key: "name", type: "string", icon: <PermIdentity fontSize="small" /> },
  { name: "Employee ID", key: "emp_id", type: "string", icon: <Badge fontSize="small" /> },
  { name: "PT Site", key: "site", type: "autocomplete", icon: <AddHome fontSize="small" /> },
  { name: "Issue", key: "issue", type: "string", icon: <Source fontSize="small" /> },
  { name: "Severity", key: "severity", type: "autocomplete", icon: <Bolt fontSize="small" /> },
  { name: "Impact", key: "impact", type: "string", icon: <Workspaces fontSize="small" /> },
  { name: "Fix in", key: "fix_in", type: "autocomplete", icon: <ManageAccounts fontSize="small" /> },
];
